import { ConfigService } from '@axo/config';
import { useTranslation } from '@axo/shared/i18n';
import { LoanProductAside } from '@axo/ui-feature/features/ProductAside';
import { LoanProductAsideProps } from '@axo/ui-feature/features/ProductAside/LoanProductAside';
import { TrustPilotDataProps } from '@axo/ui-feature/features/TrustPilotWidget';
import { getTrustPilotWidgetData } from '@axo/ui-feature/features/TrustPilotWidget/services/get-trustpilot-widget-data';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useAxoFormContext } from '../../../../context/AxoForm/AxoForm';

const labels: Partial<LoanProductAsideProps['labels']> = {
  progress: {
    progress: 6,
    labels: {
      title: '{{progress}}% valmiina!',
      description: '',
    },
  },
  trustpilot: {
    // @ts-expect-error - data is added later
    data: {},
    market: 'fi',
  },
};

const stepProgressForLoan = [
  {
    step: 1,
    progress: 0,
    description: '',
  },
  {
    step: 2,
    progress: 33,
    description: 'Jatka samaan tahtiin!',
  },
  {
    step: 3,
    progress: 50,
    description: 'Jatka samaan tahtiin!',
  },
  {
    step: 4,
    progress: 67,
    description: 'Lähes perillä! Hakemus on hetkessä valmis.',
  },
  {
    step: 5,
    progress: 83,
    description: 'Jatka samaan tahtiin',
  },
  {
    step: 6,
    progress: 90,
    description: 'Jatka samaan tahtiin!',
  },
];

export const Aside = ({ isWL }: { isWL?: boolean }) => {
  const { t } = useTranslation();
  const { step } = useAxoFormContext();

  const [trustpilotData, setTrustpilotData] = useState<TrustPilotDataProps>();

  const keyBenefits = t('KeyBenefits', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const _labels = {
    ...labels,
    usps: step > 1 ? undefined : keyBenefits.map((b) => <Trans>{b}</Trans>),
    progress:
      step > 1
        ? {
            ...labels.progress,
            progress: stepProgressForLoan[step - 1].progress,
            labels: {
              ...labels.progress?.labels,
              description: stepProgressForLoan[step - 1].description,
            },
          }
        : undefined,
    trustpilot: {
      ...labels.trustpilot,
      data: trustpilotData,
    },
    wlPoweredBy: isWL
      ? {
          locale: ConfigService.get('global').i18n.defaultLocale,
          brand: ConfigService.get('global').brand,
        }
      : undefined,
  };

  useEffect(() => {
    let ignore = false;

    if (ignore) return;

    const fetchTrustpilotData = async () => {
      const locale = ConfigService.get('global').i18n.defaultLocale;
      const { id, businessUnitId } =
        ConfigService.get('site').services.trustpilot;
      const data = await getTrustPilotWidgetData(id, businessUnitId, locale);
      setTrustpilotData(data);
    };

    fetchTrustpilotData();

    return () => {
      ignore = true;
    };
  }, []);

  return (
    <LoanProductAside labels={_labels as LoanProductAsideProps['labels']} />
  );
};
